import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";
import Upload from '../Ui/Upload';
import { toastMessage } from '../../utils/toast';
import { AiOutlineDelete } from "react-icons/ai";
import * as jobActions from '../../Redux/Actions/jobs';
import pdfImg from '../../assets/images/pdf_img.png';
import { useEffect } from 'react';
import CONFIG from '../../config';
import { resetFileName } from '../../utils/resetFileName';

function CustomDocumentModal({ t, showModal, handleCancel, handleOk, jobId, footerOption1, footerOption2 }) {

    const [attachmentsId, setAttachmentsId] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [buttonLoading, setButtonLoading] = useState(false);

    useEffect(() => {
        if(attachments?.length !== 0 && attachmentsId?.length === attachments?.length) {
            const payload = {
                jobID: jobId,
                documentIds: attachmentsId
            };
            jobActions.addBackOfficeDocumentIds(payload).then(res => {
                if(res?.status === 200) {
                    setButtonLoading(false);
                    toastMessage('success', "Documents uploaded Successfully!");
                    handleOk();
                    window.location.reload();
                }
            }).catch(err => {
                toastMessage('error', 'Unable to upload documents. Try later!');
                setButtonLoading(false);
            })
            setAttachmentsId([]);
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attachmentsId]);
    
    const handleUploadAdditionalPayment = (files) => {
        if(files?.length <= CONFIG.docUploadCount && (attachments?.length + files?.length <= CONFIG.docUploadCount)) {
            const chosenFiles = Array.prototype.slice.call(files);
            chosenFiles.forEach((file, i) => {
                let woExtensionName = file?.name.toLowerCase().split('.');
                if(!(['jpeg', 'jpg', 'pdf', 'png'].includes(woExtensionName[woExtensionName?.length-1]))) {
                    chosenFiles.splice(i, 1);
                    toastMessage('error', 'Un Supported Media type!');
                } else {
                    setAttachments([...attachments ,...chosenFiles]);
                }
            });
        } else {
            toastMessage('error', `You can only upload ${CONFIG.docUploadCount} documents!`);
        }
    };
    
    const handleSubmit = () => {
        let attachment = [];
        setButtonLoading(true);
        attachments.forEach(file => {
            let data = new FormData();
            data.append('jobId', jobId);
            data.append('file', resetFileName(file));
            let woExtensionName = file?.name.toLowerCase().split('.');
            data.append('extension', '.' + woExtensionName[woExtensionName?.length-1]);
            jobActions.uploadPaymentReceipt(data).then(res => {
                if(res?.data) {
                    attachment.push(res.data);
                    attachments.length === attachment?.length && setAttachmentsId([...attachment]);
                }
            }).catch(err => {
                toastMessage('error', 'Unable to update Documents!');
                setButtonLoading(false);
            })
        });
    }

    const handleDelete = (index) => {
        const data = [...attachments];
        data.splice(index, 1)
        setAttachments(data);
    }
    
  return (
    <div>
        <div className="modal" style={{display: (showModal ? 'block': '')}}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{t("jobsManagement.infoJob.customDocuments.title")}</h5>
                        <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                            <MdClose />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex flex-column mb-3">
                            <div className='d-flex'>
                                <label className="form-label mb-3">{"Custom Document Upload"}</label>
                                <p className='mx-1'>(only *jpg, *jpeg, *png, *pdf formats are allowded)</p>
                            </div>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                                {attachments?.length ? 
                                    attachments.map((file, index) => (
                                        <div key={file.name}>
                                            <img alt="Document Preview" src={file?.name.includes(".pdf") ? pdfImg : URL.createObjectURL(file)} style={{ width:'100px', height:'100px', margin: '0 0 5px 0' }} />
                                            <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => {handleDelete(index)}} />
                                        </div>
                                    )) : null}
                            </div>
                            <div>
                                <Upload multiple={true} onChange={e => handleUploadAdditionalPayment(e.target.files)} />
                                <p>(Press <strong>clrt + click</strong> to select two files)</p>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">  
                        <button type="button" className="btn btn-light-danger font-weight-bold" disabled={buttonLoading} onClick={handleCancel}>{footerOption2 ? footerOption2 : t("jobsManagement.infoJob.createReference.close")}</button>
                        <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={buttonLoading || !attachments.length} onClick={() => handleSubmit()}>{footerOption1 ? footerOption1 : t("jobsManagement.infoJob.createReference.ok")}
                            {(buttonLoading) && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal-backdrop show"></div>
    </div>
  )
}

export default CustomDocumentModal;